// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoWithIcon_container__wRQL_","icon":"InfoWithIcon_icon__armf4","text":"InfoWithIcon_text__RZ2_0"};